import { useSelector } from 'react-redux';
import { useCrossdockingContext } from '.';
import { useEffect } from 'react';

export default function useExternalSearchSync() {
  const { ordersToRetrieveFilters } = useSelector((state) => state.orders);
  const { setFilters } = useCrossdockingContext();

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      orderSearch: ordersToRetrieveFilters.filter,
    }));
  }, [ordersToRetrieveFilters.filter, setFilters]);
}
